module.exports = __webpack_public_path__ + "img/0.471e06ab.jpg";